// extracted by mini-css-extract-plugin
export var wraper = "OneSidedCard-module--wraper--1kmX8";
export var reverse = "OneSidedCard-module--reverse--1fjKg";
export var content = "OneSidedCard-module--content--3MVQ7";
export var accordion = "OneSidedCard-module--accordion--1G7jv";